import Vue from 'vue'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)
const isAdminOrPartner = () => {
  const roles = localStorage.getItem('access_roles')
  const userRoles = roles?.split(',')
  return userRoles?.includes('ROLE_ADMIN') || userRoles?.includes('ROLE_PARTNER')
}
const link = (data) => {
  const appointmentId = data?.id
  const endpointPath = isAdminOrPartner() ? '/admin-appointment' : '/appointments'

  if (!appointmentId) return ''

  return `
    <a href="${endpointPath}/${appointmentId}" target="_blank" class="v-btn v-btn--flat theme--light v-btn--block primary--text v-btn--outlined v-btn--depressed py-2 mt-5">
      <span class="caption" style="font-size: 12px; font-weight: bold;">
        ${translate(area + 'moreDetails')}
      </span>
    </a>
  `
}

export default link
